'use client';

import { useFlag } from '@unleash/proxy-client-react';

import type { FeatureFlag } from '@/common/constants/feature-flag.enum';

export { useFlagsStatus as useFeatureFlagsStatus } from '@unleash/proxy-client-react';

export function useFeatureFlag(featureFlag: FeatureFlag): boolean {
  return useFlag(featureFlag);
}
